<template>
  <div id="row_0" class="error-500-cont">
    <div class="grid-x">
      <div class="cell small-12">
        <img
          class="img-adaptive stretch default-homepage"
          :src="`${assetHost}/page/home-page/latest/images/default_homepage_02.png`"
          alt="testbanner1.1.1"
          usemap="#map1288909"
          data-mapped="y"
          width="1200"
          height="600"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useEnvProps } from '@/stores/envProps';

const envPropsStore = useEnvProps();
const assetHost = computed(() => envPropsStore?.envProps?.navigationAssetHost ?? '');
</script>

<style lang="scss" scoped>
.error-500-cont {
  padding: 0 rem-calc(20px);
  .default-homepage {
    max-width: 100%;
    width: 100%;
    height: auto;
  }
}
</style>
